/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import InvoiceListCard from './InvoiceListCard'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'
import { getInvoiceCreateLink } from '../../lib/links/invoiceLinks'

function InvoiceListPage () {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'invoices',
    defaultMessage: 'Factures'
  })

  const [searchParams, setSearchParams] = useQueryParams()

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <InvoiceListCard
          createLink={getInvoiceCreateLink({
            customerId: searchParams.customerId,
            leaseId: searchParams.leaseId,
            type: searchParams.type?.length === 1 ? searchParams.type[0] : undefined
          })}
          query={searchParams}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default InvoiceListPage
